// Two-step permanent delete for admins: "Delete" opens a confirmation (optionally asking
// for a word to be typed), and a refusal from the server is shown in place.

import { useState } from "react";
import { errorText } from "../hooks";

export function DeleteButton({ what, onDelete, onDone, typeToConfirm, warning }: {
  /** Shown in the button and the question, e.g. "site Moorfields". */
  what: string;
  onDelete: () => Promise<unknown>;
  onDone: () => void;
  /** If set, this exact text must be typed to enable the delete. */
  typeToConfirm?: string;
  /** What else goes with it. */
  warning?: string;
}) {
  const [open, setOpen] = useState(false);
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (!open) {
    return <button className="link danger" onClick={() => { setOpen(true); setError(null); }}>Delete</button>;
  }
  const ok = !typeToConfirm || typed.trim() === typeToConfirm;
  const go = async () => {
    setBusy(true);
    setError(null);
    try {
      await onDelete();
      setOpen(false);
      onDone();
    } catch (e) {
      setError(errorText(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <span className="delete-confirm" role="group" aria-label={`Delete ${what}`}>
      <span className="small">Delete {what} permanently?{warning ? ` ${warning}` : ""}</span>
      {typeToConfirm && (
        <input aria-label={`Type ${typeToConfirm} to confirm`} placeholder={`type ${typeToConfirm}`} value={typed}
          onChange={(e) => setTyped(e.target.value)} style={{ width: "9rem" }} />
      )}
      <button className="danger" disabled={!ok || busy} onClick={() => void go()}>Delete permanently</button>
      <button className="secondary" onClick={() => setOpen(false)}>Cancel</button>
      {error && <span className="error small">{error}</span>}
    </span>
  );
}
